import { render, staticRenderFns } from "./FundWarnTips.vue?vue&type=template&id=112ff332&scoped=true&"
import script from "./FundWarnTips.vue?vue&type=script&lang=js&"
export * from "./FundWarnTips.vue?vue&type=script&lang=js&"
import style0 from "./FundWarnTips.vue?vue&type=style&index=0&id=112ff332&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112ff332",
  null
  
)

export default component.exports